module.exports = __webpack_public_path__ + "img/writingSeminar_041022_C.3c4f3ab8.jpg";